import { render, staticRenderFns } from "./Form_3.vue?vue&type=template&id=33b1210a&scoped=true"
import script from "./Form_3.vue?vue&type=script&lang=js"
export * from "./Form_3.vue?vue&type=script&lang=js"
import style0 from "./Form_3.vue?vue&type=style&index=0&id=33b1210a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b1210a",
  null
  
)

export default component.exports